export default {
    props: {
        applicant: {
            type: Object,
            required: true,
        },
    },
    computed: {
        program() {
            return this.applicant.student
                ? this.$_.get(this.applicant, "student.programs[0]", {})
                : {};
        },
        session() {
            return this.applicant.student
                ? this.$_.get(this.applicant, "student.sessions[0]", {})
                : {};
        },
        instructor() {
            return this.applicant.student
                ? this.$_.get(this.applicant, "student.instructor", {})
                : {};
        },
        isStudent() {
            return this.applicant.student
                ? Object.keys(this.applicant.student).length > 0
                : false;
        },
        student() {
            return this.applicant.student &&
                Object.keys(this.applicant.student).length > 0
                ? this.applicant.student
                : {};
        },
    },
};
